<template lang="pug">
  .crud
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=12)
          div
            h2 {{ $t('strings.commissions') }}:
            span {{ $t('strings.description', {attribute: $t('strings.commissions')}) }}
      vm-tabs
        vm-tab(vm-label='Comisiones abiertas' @click="flag = false")
          OpenCommissionsTab
        vm-tab(vm-label='Comisiones cerradas' @click="flag = false")
          ClosedCommissionsTab
        vm-tab(vm-label='Graficas' @click="flag = false" v-if="$auth.check('Admin')")
          GraphicsTab
</template>

<script>
import OpenCommissionsTab from '@/components/commissions/OpenCommissionsTab.vue'
import ClosedCommissionsTab from '@/components/commissions/ClosedCommissionsTab.vue'
import GraphicsTab from '@/components/commissions/GraphicsTab.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('CommissionsV2')

export default {
  name: 'TheCommissions',
  components: {
    OpenCommissionsTab,
    ClosedCommissionsTab,
    GraphicsTab
  },
  data: () => ({
    currentPage: 1,
    columnsOrderBy: [
      'sale_folio',
      'quotation_folio',
      'customer_name',
      'seller_name',
      'sale_total',
      'sale_subtotal',
      'currency',
      'exchange_rate',
      'sale_total_mxn',
      'sale_subtotal_mxn',
      'commission_percentage',
      'calculated_commission'
    ],
    attributeModal: 'name',
    filters: {
      where: {
        sale: {
          folio: ''
        },
        status: '',
        param: ''
      },
      whereIn: {},
      whereBetween: {

      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['commissions'])
  },
  watch: {

  },
  methods: {
    ...mapActions([
      'loadCatalogV2'
    ])
  }
}
</script>

<style lang="scss">
.scrollable {
  position: relative;
}

.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.check {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: absolute;
  top: calc(50% - 5px);
  right: 0;
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
.vm-chip-success {
  background: rgba(var(--success), 1) !important;
}
.vm-chip-primary {
  background: rgba(var(--primary), 1) !important;
}
.vm-chip-warning {
  background: rgba(var(--warning), 1) !important;
}
.vm-table--thead-table th {
  white-space: nowrap;
}
</style>
